import getMuiTheme from 'material-ui/styles/getMuiTheme';
import {
  cyan500, cyan700, pinkA200, grey900,
  grey100, grey300, grey400, grey500,
  white, darkBlack, fullBlack } from 'material-ui/styles/colors';
import { lighten } from 'material-ui/utils/colorManipulator';

export const useDrawer = true;

export const red = '#ED1B2D';
export const yellow = '#FF8F00';
export const black = '#221E1F';

export const primary1Color = '#54708a';
export const primary1TextColor = white;
export const drawerTextColor = grey900;
export const headerTextColor = white;

export default getMuiTheme({
  palette: {
    primary1Color,
    primary2Color: cyan700,
    primary3Color: grey400,
    accent1Color: pinkA200,
    accent2Color: grey100,
    accent3Color: grey500,
    textColor: darkBlack,
    alternateTextColor: white,
    canvasColor: white,
    borderColor: grey300,
    pickerHeaderColor: cyan500,
    shadowColor: fullBlack,
  },
  appBar: {
    height: 57,
    textColor: white,
    color: lighten(primary1Color, 0.1),
  },
  drawer: {
    width: 230,
    color: grey900,
  },
  raisedButton: {
    primaryColor: primary1Color,
  },
  tabs: {
    backgroundColor: white,
    textColor: black,
    opacity: '0',
    selectedTextColor: black,
  },
});



// WEBPACK FOOTER //
// ./src/theme.js